<template>
	<div class="list-group-item">

		<template v-if="data">

			<p class="mb-1 mt-1">
				<strong>{{data.userabout_displayname}}</strong>
				<template v-if="data.datetime">
					{{ $datetime.getLocaleStringFromTimeStamp(data.datetime, false) }}
				</template>
			</p>
			<p style="white-space: pre-wrap;">{{data.content}}</p>
			<template v-if="data.formresponse_data">
				<FormGrid :page="data.formresponse_data.pages[0]" readonly="1" viewAs="submitter"></FormGrid>
			</template>

		</template>

		<template v-else>

			{{$t('loading')}}

		</template>

	</div>
</template>

<script>
import FormGrid from "src/components/FormEditor/FormGrid";
export default {
	components: {
		FormGrid
	},
	props: ['data', 'swipedLeftItem'],
	data() {
		return {
		};
	},
	mounted() {
	},
	created: function () {
	},
	destroyed: function () {
	},
	methods: {
	},
	computed: {
	}
};
</script>
